import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { routePath } from 'app/services/helpers'
import axios from 'app/services/http/axios';

// -------

import {Actions} from './slice';
import { Api } from 'modules/Admin/Inventory'

// -------

function* getType({payload: {id}}) {
  try {
    const route = routePath(Api.type, { id })

    const response = yield call(axios.get, route);
    yield put(Actions.getTypeSuccess(response));

  } catch (e) {
    return yield put(Actions.getTypeFailed(e));
  }
}

function* save({ payload: {id, values} }) {

  console.log('id', id)
  console.log('values', values)

  try {

    if ( id === 0 ) id = 'create'
    const route = routePath(Api.type, { id })

    const response = yield call(axios.post, route, { ...values });
    yield put(Actions.saveFormSuccess(response));

    toast.success('Type has been successfully saved')

  } catch (e) {
    return yield put(Actions.saveFormFailed(e));
  }
}

export function* watchInventoryTypesFormSaga() {
  yield takeLatest(Actions.getType.type, getType)
  yield takeLatest(Actions.saveForm.type, save)
}

export default watchInventoryTypesFormSaga
